import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const BookOpenIcon = forwardRef<SVGSVGElement, Props>((props, ref) => (
	<svg
		width="1em"
		height="1em"
		viewBox="0 0 16 16"
		xmlns="http://www.w3.org/2000/svg"
		ref={ref}
		{...props}
	>
		<path
			fill="currentColor"
			fillRule="evenodd"
			clipRule="evenodd"
			d="M14.3454 2.12747C12.4571 0.674881 9.8437 0.666801 7.95141 2.075C6.06829 0.948146 3.67748 0.933515 1.78885 2.09575L1.4624 2.29664C1.17505 2.47348 1 2.78673 1 3.12414V14.1091C1 14.7979 1.77709 15.1999 2.33934 14.802L2.46632 14.7122C3.96246 13.6534 5.97363 13.6918 7.42823 14.807C7.76555 15.0656 8.23445 15.0656 8.57177 14.807C10.0264 13.6918 12.0375 13.6534 13.5337 14.7122L13.6607 14.802C14.2229 15.1999 15 14.7979 15 14.1091V3.09503C15 2.80244 14.8641 2.52646 14.6322 2.34807L14.3454 2.12747ZM8.75 3.35292C10.1133 2.26943 12.0445 2.25002 13.4309 3.31641L13.5 3.3696V12.9669C11.9924 12.2701 10.2532 12.2706 8.75 12.9595V3.35292ZM7.25 3.40418C5.82666 2.51695 4.0001 2.49625 2.575 3.37324L2.5 3.41939V12.9669C4.0076 12.2701 5.7468 12.2706 7.25 12.9595V3.40418Z"
		></path>
	</svg>
))
